import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-change-password-tooltip-item',
    templateUrl: './change-password-tooltip-item.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./change-password-tooltip-item.component.scss'],
    standalone: false,
})
export class FiChangePasswordTooltipItemComponent {
    @HostBinding('class.error')
    @Input()
    error: boolean;
}
